<template>
    <div class="job-list">
        <div class="job-list--row job-list--row__top">
            <div class="job-list--col job-list--col__filter">
                <ui-select name="region_code"
                        :value="currentRegion"
                        :label="regionSelectLabel"
                        @change="updateFilter">
                    <span slot="label">{{ regionSelectLabel }}</span>
                    <ui-option :value="regionValue" v-for="(regionLabel, regionValue) in regions" :key="regionValue">
                        {{ regionLabel }}
                    </ui-option>
                </ui-select>
            </div>
            <div class="job-list--col job-list--col__filter">
                <ui-select name="experience_code" @change="updateFilter">
                    <span slot="label">{{ experienceSelectLabel }}</span>
                    <ui-option value="">
                        {{ experienceSelectPlaceholder }}
                    </ui-option>
                    <ui-option :value="experienceValue"
                            v-for="(experienceLabel, experienceValue) in experience"
                            :key="experienceValue">
                        {{ experienceLabel }}
                    </ui-option>
                </ui-select>
            </div>
        </div>
        <div class="job-list--row">
            <div class="job-list--col job-list--col__jobs">
                <ul class="job-list--list u-reset">
                    <template v-if="filteredJobs.length">
                        <li class="job-list--item" v-for="(job, index) in filteredJobs" :key="index">
                            <figure class="job-list--figure job-list--list-col">
                                <img class="job-list--image" :src="'img/job-item.svg' | staticPath">
                            </figure>
                            <div class="job-list--text job-list--list-col">
                                <h3 class="job-list--job-title u-reset">
                                    {{ job.title }}
                                </h3>
                                <p class="job-list--job-description">
                                    {{ job.experience }} - {{ job.region.join(',') }}
                                </p>
                            </div>
                            <div class="job-list--links job-list--list-col">
                                <a class="job-list--link u-reset"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        :href="job.details_url">
                                    {{ jobDescriptionLabel }}
                                </a>
                                <a class="job-list--link u-reset"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        :href="job.apply_url">
                                    {{ applyLabel }}
                                </a>
                            </div>
                        </li>
                    </template>
                    <li class="job-list--item job-list--item__not-found" v-else>
                        <p class="job-list--job-title u-reset">
                            {{ noResultsFound }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select.vue';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option.vue';
    import Vue from 'vue';
    import { mapGetters } from 'vuex';

    const filterJobs = (activeFilters, jobs) => {
        // loop all the jobs to find the ones that should be filtered in
        return jobs.filter(job => {
            // loop all the active filters to find out whether the job item matches one of the filters
            return activeFilters.every(([key, value]) => {
                // get the job target value that we need to check
                const jobPropertyValue = job[key];

                // if the target value is an array we check if the filter values is contained in this array
                if (Array.isArray(jobPropertyValue)) {
                    return jobPropertyValue.includes(value);
                }

                // simple comparison between the job property an the active filter value
                return jobPropertyValue === value;
            });
        });
    };

    export default {
        components: {
            UiSelect,
            UiOption,
        },
        props: {
            jobs: {
                type: Array,
                required: true,
            },
            noResultsFound: {
                type: String,
                required: true,
            },
            regionSelectLabel: {
                type: String,
                required: true,
            },
            experienceSelectLabel: {
                type: String,
                required: true,
            },
            experienceSelectPlaceholder: {
                type: String,
                required: true,
            },
            applyLabel: {
                type: String,
                required: true,
            },
            jobDescriptionLabel: {
                type: String,
                required: true,
            },
            regions: {
                type: Object,
                required: true,
            },
            experience: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                activeFilters: {
                    region_code: null,
                },
            };
        },
        computed: {
            ...mapGetters('user-region', ['getSafelyUserRegion']),
            currentRegion() {
                return this.getSafelyUserRegion(this.regions);
            },
            filteredJobs() {
                const filterEntries = Object.entries(this.activeFilters).filter(([, value]) => Boolean(value));

                return filterEntries.length ? filterJobs(filterEntries, this.jobs) : this.jobs;
            },
        },
        methods: {
            updateFilter({ target }) {
                Vue.set(this.activeFilters, target.name, target.value);
            },
        },
        beforeMount() {
            Vue.set(this.activeFilters, 'region_code', this.currentRegion);
        },
    };
</script>
